<template>
  <main class="main">
    <header class="page-header">
      <h1>
        Gists
        <a href="#" title="RSS" aria-label="RSS">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" height="23">
            <path d="M4 11a9 9 0 0 1 9 9" />
            <path d="M4 4a16 16 0 0 1 16 16" />
            <circle cx="5" cy="19" r="1" />
          </svg>
        </a>
      </h1>
      <div class="post-meta">
        <span>Code scripts and essays from Github Gist profile</span>
      </div>
    </header>
    <div class="archive-year" v-if="loaded">
      <div class="archive-month">
        <h3 class="archive-month-header">Last Posts</h3>
        <div class="archive-posts">
          <Gist v-for="gist in gists" :data="gist" v-bind:key="gist.id" />
        </div>
      </div>
    </div>
    <div class="post-content" v-else>
      <h3 id="intro">Loading stuff</h3>
      <p>Please wait</p>
      <hr>
    </div>
    <footer class="page-footer" v-if="loaded">
      <span class="centering-cta">
        <a class="cta-link" href="https://gist.github.com/davidlares" target="_blank" rel="noopener noreferrer">View complete Gist page »</a>
      </span>
    </footer>
  </main>
</template>
<script>
import Gist from '@/components/Gist'
import axios from "axios"
export default {
  name: 'Gists',
  data() {
    return {
      loaded: false,
      gists: {},
    }
  },
  components: {
    Gist
  },
  async mounted() {
    await this.loadGists()
  },
  methods: {
    async loadGists() {
      let gists = await axios.get(process.env.VUE_APP_GITHUB_ENDPOINT)
      this.gists = gists.data
      this.gists.splice(5)
      this.loaded = true
    }
  }
}
</script>
